import router from '../router';
// import NProgress from "nprogress"; // progress bar
// import "nprogress/nprogress.css"; // progress bar style
// import {
//   getToken
// } from '@/utils/auth'; 
// import getPageTitle from '@/utils/get-page-title';

// function GetRequest() {
//   var url = location.search; // 获取url中"?"符后的字串
//   var theRequest = {};
//   if (url.indexOf('?') !== -1) {
//     var str = url.substr(1);
//     var strs = str.split('&');
//     for (var i = 0; i < strs.length; i++) {
//       theRequest[strs[i].split('=')[0]] = unescape(strs[i].split('=')[1]);
//     }
//   }
//   return theRequest;
// }

router.beforeEach(async (to, from, next) => {
  // NProgress.start();
  // document.title = getPageTitle(to.meta.title);
  // const hasToken = getToken();
  // if (hasToken) {
  next();
  // } else {
  // var Request = GetRequest();
  // var ket = Request["code"];
  // }
});

router.afterEach(() => {
  // NProgress.done();
});
